import React from "react";

// Portfolio-level signal only: the sum of every currency's USD gap. It never
// replaces the per-currency status - a healthy total can still hide a
// currency that can't pay out, since surplus in one currency only helps
// another after a real conversion.
function TotalGapSummary({ rows, label = "Total gap (USD), all currencies" }) {
  const gaps = rows.map((r) => Number(r.gapAmountUsd) || 0);
  const total = gaps.reduce((sum, g) => sum + g, 0);
  const shortCount = gaps.filter((g) => g < 0).length;
  const totalIsShort = total < 0;

  return (
    <div className="flex flex-wrap gap-x-8 gap-y-2 items-center px-4 py-3 mb-4 rounded border border-gray-200 bg-gray-50/50">
      <div>
        <div className="text-xs font-bold tracking-wider text-gray-500 uppercase">{label}</div>
        <div className={`text-xl font-semibold ${totalIsShort ? "text-red-600" : "text-green-700"}`}>
          {total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </div>
      </div>
      <div>
        <div className="text-xs font-bold tracking-wider text-gray-500 uppercase">Currencies short</div>
        <span
          className={`inline-block px-3 py-1 mt-1 text-xs font-medium rounded-full ${
            shortCount > 0 ? "bg-red-100 text-red-800" : "bg-green-100 text-green-800"
          }`}
        >
          {shortCount}
        </span>
      </div>
      <p className="text-xs text-gray-400 max-w-sm">
        Portfolio view only. A positive total does not cover a short currency - check each row.
      </p>
    </div>
  );
}

export default TotalGapSummary;
